export const messages = {
  empty: {
    description: {
      id: 'admin/promotions.form.regular.scope.title',
    },
    add: {
      id: 'admin/promotions.form.utils.add-items',
    },
  },
  allItemsDescription: {
    id: 'admin/promotions.form.regular.view.scope.all-items-description',
  },
  description: {
    id: 'admin/promotions.form.regular.view.scope.description',
  },
  allItems: {
    id: 'admin/promotions.form.scope.skus.select.label',
  },
  all: {
    id: 'admin/promotions.form.regular.view.scope.all',
  },
  skus: {
    id: 'admin/promotions.form.regular.view.scope.skus',
  },
  collections: {
    id: 'admin/promotions.form.regular.view.scope.collections',
  },
  categories: {
    id: 'admin/promotions.form.regular.view.scope.categories',
  },
  brands: {
    id: 'admin/promotions.form.regular.view.scope.brands',
  },
  products: {
    id: 'admin/promotions.form.regular.view.scope.products',
  },
  item: {
    id: 'admin/promotions.form.utils.item-label',
  },
}
